module.exports = __webpack_public_path__ + "static/media/materialdesignicons-webfont.a65b9561.ttf";